import React from 'react';
import Overview from '@hpstellar/pdp/Overview/Overview.js';
import KeySellingPoints from '@hpstellar/pdp/KeySellingPoints/KeySellingPoints.js';

import AboveTheFoldOnlyServerRender from '../../../shared/components/above-the-fold-only-server-render';
import withPageComponents from '../../../page/components/with-page-components';
import { Helpers } from '../../../core/src/helpers';

import { FeaturesMapper } from '../../components/tabs/features';
import PDPSection from '../pdp-section'

import './pdp-overview.less';
const NO_KEYPOINTS = {
    "hp care pack services": 1
};

const pdpOverview = ({ product, pdpFeatures, category }) => {
    if (pdpFeatures && product) {
        const { attributes, prdClass } = product;
        const { pm_category = "" } = attributes;
        const { keyPoints, featuresContent, summary, bulletPoints } = pdpFeatures;
        const categoryName = pm_category.toLowerCase();
        return (<div className={'pdp-overview'}>
            {bulletPoints && bulletPoints.length > 1
                ? <Overview
                    productCategory={category}
                    bulletPoints={bulletPoints}
                    description={summary}
                    title={''}
                /> : <Overview productCategory={category}>
                    <div dangerouslySetInnerHTML={Helpers.createMarkup(summary)} />
                </Overview>}
            {keyPoints && keyPoints.length > 0 &&
                <KeySellingPoints
                    data={pdpFeatures.keyPoints}
                    className={categoryName.indexOf('services') > -1 ? 'services' : undefined} />}
            {
                featuresContent &&
                <AboveTheFoldOnlyServerRender skip={true} offset={1000} >
                    <PDPSection showTitle={false}>
                        <FeaturesMapper features={pdpFeatures} />
                    </PDPSection>
                </AboveTheFoldOnlyServerRender>
            }
        </div>);
    }
    return null;
}

export default withPageComponents(pdpOverview, { components: ['product', 'pdpFeatures'] })
